import type { DetailPageConfig } from "@/components/shared/UniversalDetailPage/types/detailPage";
import type { App_Users } from "@/src/gql/graphql";
import { adminUserDetailTabs } from "./admin-user-detail-tabs";
import { adminUserDetailActions } from "../admin-users-actions";

// ============================================================================
// ADMIN USER DETAIL PAGE CONFIGURATION
// ============================================================================
// Drives the registry-based detail modal (UniversalDetailModalContainer) so the
// admin user detail view shares the same chrome/header/navigation as contacts.
// Typed against the codegen App_Users row (satisfies BaseEntity).
// ============================================================================

const adminUserTitleTemplate = (user: App_Users): string => {
  const full = [user.first_name, user.last_name].filter(Boolean).join(" ").trim();
  return full || user.email || "User";
};

export const ADMIN_USER_DETAIL_CONFIG: DetailPageConfig<App_Users> = {
  entity: "admin_users",
  displayName: "User",
  tabs: adminUserDetailTabs as unknown as DetailPageConfig<App_Users>["tabs"],
  actions: adminUserDetailActions as unknown as DetailPageConfig<App_Users>["actions"],
  defaultTab: "overview",
  showHeader: true,
  showBreadcrumbs: false,
  showActions: true,
  titleTemplate: adminUserTitleTemplate,
  descriptionTemplate: (user: App_Users) => user.email ?? "",
};
